import { List } from "./_components/list";
import { Panel } from "./_components/panel";
import { Root } from "./_components/root";
import { Tab } from "./_components/tab";

export const Tabs = {
    Root,
    List,
    Tab,
    Panel,
};

export type { RootProps as TabsRootProps } from "./_components/root";
export type { ListProps as TabsListProps } from "./_components/list";
export type { TabProps as TabsTabProps } from "./_components/tab";
export type { PanelProps as TabsPanelProps } from "./_components/panel";
